<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <h5>注文一覧</h5>
            </div>
            <div class='table-container'>
                <table class='table is-striped is-hoverable is-fullwidth'>
                    <thead>
                        <tr>
                            <th class='order_number'>注文番号</th>
                            <th class='lab-name'>店舗名</th>
                            <th class='name'>お名前</th>
                            <th class='email'>メールアドレス</th>
                            <th class='address'>住所</th>
                            <th class='size'>サイズ</th>
                            <th class='delivery'>配送方法</th>
                            <th class='payment'>決済方法</th>
                            <th class='quantity'>数量</th>
                            <th class='amount'>料金</th>
                            <th class='status'>状態</th>
                            <th class='created_at'>注文日</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for='order in displayOrders' :key='order.id'>
                            <td>{{ order.order_number }}</td>
                            <td>{{ order.lab_name }}</td>
                            <td>{{ order.name }}</td>
                            <td>{{ order.email }}</td>
                            <td>{{ order.address }}</td>
                            <td>{{ order.size }}</td>
                            <td>{{ order.delivery }}</td>
                            <td>{{ order.payment }}</td>
                            <td>{{ order.quantity }}</td>
                            <td>{{ order.amount }}</td>
                            <td>{{ order.status }}</td>
                            <td>{{ order.created_at }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Order',
    components: {
    },
    data () {
        return {
            orders: [],
            viewOrderPage: 0
        }
    },
    computed: {
        displayOrders () {
            const self = this

            const array = self.orders.map((x) => {
                if (x.status === 0) x.status = '未決済'
                else if (x.status === 1) x.status = '支払済'
                else if (x.status === 2) x.status = '完了'

                x.created_at = self.getDate(x.created_at)

                return x
            })

            return array.splice(0, (this.viewOrderPage + 1) * 20)
        }
    },
    mounted () {
        const self = this
        const addViewOrders = () => {
            const bottomOfWindow = window.scrollY + window.innerHeight >= document.documentElement.offsetHeight
            if (bottomOfWindow) {
                self.viewOrderPage++
            }
        }
        addViewOrders()
        window.addEventListener('scroll', addViewOrders)

        self.axios.get(`${process.env.API_URL}/admin/order`).then((res) => {
            self.orders = res.data.orders
        }).catch((e) => {
            self.$root.$emit('notification', 'is-danger', 'サーバーエラーが発生しました')
        })
    },
    methods: {
        getDate (x) {
            const date = new Date(x)

            const y = date.getFullYear()
            const m = ('0' + (date.getMonth() + 1)).slice(-2)
            const d = ('0' + date.getDate()).slice(-2)
            const h = ('0' + date.getHours()).slice(-2)
            const mn = ('0' + date.getMinutes()).slice(-2)
            const s = ('0' + date.getSeconds()).slice(-2)

            return `${y}-${m}-${d} ${h}:${mn}:${s}`
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    padding: 25px;
    margin: auto;
    min-width: 880px;
}

.buttons {
    margin: 0;
}

.buttons > button {
    height: 35px;
}

.quantity, .amount, .status, .selectbox {
    min-width: 60px;
}

.size {
    min-width: 90px;
}

.name, .delivery, .payment, .created_at, .lab-name {
    min-width: 120px;
}

.email {
    min-width: 210px;
}

.address {
    min-width: 320px;
}

th {
    max-width: 300px;
}

.status {
    min-width: 80px;
}

.checkbox {
    width: 20px;
    height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/pages/Order.vue